import { QueryDispatcher } from "../../shared/domain/QueryDispatcher";

export class ContractBankQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(): Promise<any> {            
    let data = await this.dispatcher.dispatch('check.user.has.active.bank.contract', {});
    this.frontend.contractBankActive = data;    
  }
}